import { useMutation } from '@tanstack/react-query';
import { integrationsApi } from 'src/services';

export type SyncEncounterPayload = {
  org_uuid: string;
  fhirPatientId: string;
  fhirEncounterId: string;
  fhirAppointmentId?: string;
};

export type SyncEncounterResponse = {
  code: number;
  message: string;
  success: boolean;
};

export const syncEncounter = async (
  payload: SyncEncounterPayload
): Promise<SyncEncounterResponse> => {
  const response = await integrationsApi.post<SyncEncounterResponse>(
    '/v2/op/sync-encounter',
    payload
  );
  return response.data;
};

export const useSyncEncounter = () => {
  return useMutation({
    mutationKey: ['syncEncounter'],
    mutationFn: (payload: SyncEncounterPayload) => syncEncounter(payload),
  });
};
